import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import Reveal from "@/components/Reveal";
import { useLanguage } from "@/i18n/useLanguage";

const HomeNewsletterCta = () => {
  const { t } = useTranslation();
  const { localize } = useLanguage();

  return (
    <section className="relative py-12 md:py-16 px-4 sm:px-6 bg-background">
      <div className="container mx-auto max-w-5xl">
        <Reveal>
          <div className="rounded-2xl border border-border bg-card p-6 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
                <Mail className="w-5 h-5" />
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-semibold text-foreground">
                  {t("newsletter.homeCta.heading")}
                </h2>
                <p className="text-muted-foreground mt-1 text-sm md:text-base">
                  {t("newsletter.homeCta.lead")}
                </p>
              </div>
            </div>
            <Link
              to={localize("/newsletter")}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors shrink-0"
            >
              {t("newsletter.homeCta.button")}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default HomeNewsletterCta;
